/**
 * Created by Z207644 on 11/6/2016.
 */
/**
 * ITPR023507 - EPIC SSO project - Mar 2018 release - SP 12292017
 * Updated model to capture Dual HBS and Care team indicator
 */
'use strict';
angular.module('cvsApp').factory('patientInfoFromRxDetailsModel',['commonModel', 'patientInfoModel',function(CM, PIM) {

    var patientInfoFromRxDetailsModel = function(){

        var self = this;

        this.apiResponse = {};
        this.header = {}
        /**
         * SP 11/13/2016 - ITPR015400 - Guest Refill
         * Captuing Patient info model along with this model
         */
        this.setResponse = function(data){
            CM.setResponse(data);
            // PIM.setResponse(data);
            // PIM.setHeader();
        }
        /**
         * SP 11/13/2016 - ITPR015400 - Guest Refill
         * initiating patient info model along with this model
         */
        this.getResponse = function(){
            self.apiResponse = CM.getResponse();
            self.header = CM.getHeader();
            PIM.getResponse();
            return self;
        }

        this.showView = function(){
            if(self.apiResponse.isViewError){
                return !self.apiResponse.isViewError;
            }
            return true;
        }

        this.getError = function(){
            if(self.apiResponse.showError){
                return self.apiResponse.showError;
            }
            return '';
        }

        var getHeader = function () {
            return self.apiResponse.response.header;
        }

        this.getRXHistoryDetails = function(){
            var rxDetails = [];
            if(!self.apiResponse.showError && self.apiResponse.rxHistory){
                if(_.isArray(self.apiResponse.rxHistory.rxDetails)){
                    return processRxDetails(self.apiResponse.rxHistory.rxDetails);
                }else{
                    if(self.apiResponse.rxHistory.rxDetails)
                        rxDetails.push(self.apiResponse.rxHistory.rxDetails);
                    return processRxDetails(rxDetails);
                }
            }
            return processRxDetails(rxDetails);
        }

        var processRxDetails = function(rxDetails){
            return _.each(rxDetails, function(rx){
                rx.fillStatus = processFillStatus(rx.fillStatus);
                rx.rxStatus = processRxStatus(rx.rxStatus);
                rx.firstFillIndicator = rx.hasOwnProperty('firstFillIndicator') ?( rx.firstFillIndicator === '' ? 'N' : rx.firstFillIndicator) : 'N';
                return rxDetails;
            });
        }

        var processFillStatus = function (fillStatus) {
            var fillStatusMap = {
                'inprocess': 'In Process',
                'readytoship': 'Ready to Ship',
                'shippedtopatient': 'Shipped to Patient',
                'shippedtocvsretailstore': 'Shipped to CVS Retail Store',
                'shippedtoprescriber':'Shipped to Prescriber',
                'shippedtoother': 'Shipped to Other',
                'waitingbin': 'Waiting Bin',
                'returned': 'Returned',
                'cancelled': 'Cancelled',
                'sold':'Sold'
            }
            if(fillStatus){
                var myFillStatus = fillStatusMap[fillStatus.replaceAll(' ', '').replaceAll('_', '').toLowerCase()];
                if(!myFillStatus) {
                    myFillStatus = fillStatus;
                }
                return myFillStatus;
            }
            return fillStatus;

        }

        var processRxStatus = function (refillStatus) {
            var rxStatusMap = {
                'active': 'Active',
                'pendingpatientcontact': 'Pending Patient Contact',
                'inprocess': 'In Process',
                'papending': 'PA Pending',
                'inactive':'Inactive'
            }

            if(refillStatus){
                return rxStatusMap[refillStatus.replaceAll(' ', '').replaceAll('_', '').toLowerCase()];
            }
            return refillStatus;
        }

        this.getPatientPrimaryAddress = function(addressType){

            if(!self.apiResponse.showError){
                var data = self.apiResponse.patientProfile.patientsAddresses.patientsAddress;

                if(_.isArray(data)){
                    for(var items in data){
                        if(data[items].addressType == addressType){
                            return data[items];
                        }
                    }
                }else{
                    if(data.addressType==addressType){
                        return data;
                    }
                }
                return {};
            }
        }

        this.getFirstAddress = function(){
            if(!self.apiResponse.showError){
                var data = self.apiResponse.patientProfile.patientsAddresses.patientsAddress;

                if(_.isArray(data)){
                    return data[0];
                }else{
                    return data;
                }
                return {};
            }
        }

        this.getPatientAllAddress = function(){
            if(!self.apiResponse.showError){
                var data = self.apiResponse.patientProfile.patientsAddresses.patientsAddress;

                if(_.isArray(data)){
                    return data;

                }else{
                    var address = [];
                    address.push(data);
                    return address;
                }

            }
        }

        this.getFirstPhoneNo = function(){
            if(!self.apiResponse.showError){
                var data = self.apiResponse.patientProfile.phones;

                if(_.isArray(data)){
                    return data[0];
                }else{
                    return data;
                }
                return {};
            }
        }
        /**
         * ITPR023507 - EPIC SSO project - Mar 2018 release - SP 12292017
         * Updated model to capture Dual HBS and Care team indicator
         */
        this.getPatientInfo = function(){
            if(!self.apiResponse.showError){
                var data = self.apiResponse.patientProfile;

                return {
                    firstName:data.firstName?data.firstName:'',
                    lastName:data.lastName?data.lastName:'',
                    dateOfBirth:data.dateOfBirth?data.dateOfBirth:'',
                    gender:data.gender?data.gender:'',
                    phones:data.phones,
                    benefitPlan:data.benefitPlan ? data.benefitPlan:'',
                    patientAccordantStatus:data.patientAccordantStatus ? data.patientAccordantStatus :'',
                    memberStatus: data.memberStatus ? data.memberStatus : false,
                    patientsMedicalConditions: data.patientsMedicalConditions,
                    catsOnlyPatient: data.catsPatientOnly,
                    medicareIndicator: data.medicareIndicator,
                    dualHBSIndicator: (data.hasOwnProperty('dualHBSIndicator') && data.dualHBSIndicator === "true"),
                    careTeamIndicator: (data.hasOwnProperty('careTeamPatientIndicator') && data.careTeamPatientIndicator === "true"),
                    refId: self && self.hasOwnProperty('getHeader') && self.getHeader()['refId']
                };
            }

        }

        this.getToken = function(){
            if(!self.apiResponse.showError){
                return CM.getHeader().tokenID;
            }
        }

        this.getGuestRxInputHash = function(){
            if(!self.apiResponse.showError){
                return self.apiResponse.guestRxNumberInputHash;
            }
        }

        this.getPatientId = function(){
            try{
            if(!self.apiResponse.showError){
                return self.apiResponse.hasOwnProperty('specialtyUserEnc')? self.apiResponse.specialtyUserEnc.patientIdentifiersEnc.patientIdentifierEnc.sourceSystemKeyValueEnc: null ;
            }
            }
            catch(ex){
                return null;
            }
        }



    }

    return new patientInfoFromRxDetailsModel();
}]);

